import type { Typo3TourItem } from '@/types/typo3'

export const DIFFICULTY_ORDER = ['EASY', 'INTERMEDIATE', 'DIFFICULT'] as const

export interface DifficultyOption {
  value: string
  label: string
}

/**
 * Collects the distinct difficulty levels present in a tour list.
 *
 * Difficulty is not delivered as a TYPO3 facet group, so the filter options are
 * derived from the items themselves. The label comes from the localized
 * `difficultyLabel` of the first item with that difficulty. Entries without a
 * label (for example `ACCESS-TRAIL` or `UNKNOWN`) are skipped.
 */
export default function getDifficultyOptions(
  items?: Typo3TourItem[]
): DifficultyOption[] {
  const found = new Map<string, string>()

  items?.forEach((item) => {
    const value = item?.difficulty
    const label = item?.difficultyLabel?.trim()

    if (value && label && !found.has(value)) {
      found.set(value, label)
    }
  })

  const rank = (value: string) => {
    const index = (DIFFICULTY_ORDER as readonly string[]).indexOf(value)
    return index === -1 ? DIFFICULTY_ORDER.length : index
  }

  return Array.from(found, ([value, label]) => ({ value, label })).sort(
    (a, b) => rank(a.value) - rank(b.value)
  )
}
